
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import DealModal from './DealModal';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import Swal from 'sweetalert2';
import { Card } from 'react-bootstrap';
import DealsbyStage from './DealsbyStage';
import { FaFilter } from "react-icons/fa";
import DealDetails from './DealDetails';

const WithCreatePermission = withPermission(({ children }) => children, ['deal-create']);
const WithEditPermission = withPermission(({ children }) => children, ['deal-edit']);
const WithDeletePermission = withPermission(({ children }) => children, ['deal-delete']);

const DealList = ({ }) => {
    const didFetchRef = useRef(false);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [dateFilterDropdown, setDateFilterDropdown] = useState(false);
    const [dateRange, setDateRange] = useState({ from: '', to: '' });
    const didInitialFetch = useRef(false);
    const [deals, setDeal] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [organisations, setOrganisation] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedDealId, setSelectedDealId] = useState(null);
    const [selectedDealData, setSelectedDealData] = useState(null);
    const [contacts, setContacts] = useState([]);
    const [errors, setErrors] = useState({});
    const [showLeadOffcanvas, setShowLeadOffcanvas] = useState(false);
    const [orgFilter, setorgFilter] = useState('');
    const [stageFilter, setStageFilter] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [filterDropdown, setFilterDropdown] = useState(null);
    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchDeal(1, searchQuery);
        }, searchQuery ? 1500 : 0);

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery, orgFilter, stageFilter, typeFilter]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };

    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const viewCurrency = userInfo?.user?.view_currency || 'AED';
    const exchangeRate = parseFloat(localStorage.getItem('exchange_rate') || 3.672);

    const formatCurrency = (amount, deal, precision = 2) => {
        let displayAmount = Number(amount || 0);
        const dealCurrency = (
            (deal?.transaction_type === 'partner' ? deal?.partner?.currency : null) || 
            deal?.organisation?.currency || 
            deal?.quotation?.project?.client?.currency || 
            'AED'
        ).toUpperCase();

        const viewCurr = viewCurrency.toUpperCase();

        if (viewCurr === 'USD' && dealCurrency !== 'USD') {
            displayAmount = displayAmount / exchangeRate;
        } else if (viewCurr === 'AED' && dealCurrency === 'USD') {
            displayAmount = displayAmount * exchangeRate;
        }

        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: viewCurrency,
            minimumFractionDigits: precision,
            maximumFractionDigits: precision
        }).format(displayAmount);
    };

    const fetchDeal = async (page = 1) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            let params = { page };

            if (searchQuery) params.search = searchQuery;
            if (dateRange?.from) params.from_date = dateRange.from;
            if (dateRange?.to) params.to_date = dateRange.to;
            if (orgFilter) params.organisation_id = orgFilter; // Only add if not empty
            if (typeFilter) params.lead_source = typeFilter;
            if (stageFilter) params.stage = stageFilter; // Only add if not empty
            const response = await axios.get(`${backendUrl}/api/deals`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                params,
            });

            if (response.data && response.data.data) {
                const { data, current_page, last_page } = response.data.data;
                setDeal(data || []);
                setCurrentPage((current_page || 1) - 1);
                setPageCount(last_page || 0);
            }
        } catch (error) {
            console.error(`Error fetching :`, error);
        }
    };


    const fetchOrganisation = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/organisation`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            const data = response.data.data;

            setOrganisation(data);

        } catch (error) {
            console.error(`Error fetching :`, error);
        }
    };
    useEffect(() => {
        fetchOrganisation();
    }, []);
    const addDeal = async (newDeal) => {
        try {


            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for adding
            const response = await axios.post(`${backendUrl}/api/deals`, newDeal, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            const createdDeal = response.data.data;

            if (createdDeal) {
                setDeal((prevDeal) => [...prevDeal, createdDeal]);
            } else {
                console.error('Creation failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error(`Error adding organisation`, error);
            }
        }
    };


    const editDeal = async (contactId, updatedData) => {
        try {

            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Corrected API endpoint with dynamic contact_type for editing
            const response = await axios.put(`${backendUrl}/api/deals/${contactId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });
            const updatedDeal = response.data.Data;

            if (updatedDeal) {
                setDeal((prevDeal) =>
                    prevDeal.map((contact) => (contact.id === updatedDeal.id ? updatedDeal : contact))
                );
            } else {
                console.error('Update failed, no data returned.');
            }

            handleCloseModal();
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else
                console.error(`Error updating`, error);
        }
    };

    const deleteDeal = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Please provide a reason for deleting this opportunity:",
            input: 'textarea',
            inputPlaceholder: 'Type your reason here...',
            inputAttributes: {
                'aria-label': 'Type your reason here'
            },
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            preConfirm: (reason) => {
                if (!reason || reason.trim() === "") {
                    Swal.showValidationMessage('Deletion reason is required');
                }
                return reason;
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                const deletionReason = result.value;
                try {
                    const backendUrl = process.env.REACT_APP_BACKEND_URL;
                    const userInfo = JSON.parse(localStorage.getItem('user-info'));
                    const origin = localStorage.getItem('user-origin');
                    const token = userInfo?.token;

                    // Corrected API endpoint with dynamic contact_type for deleting
                    await axios.delete(`${backendUrl}/api/deals/${id}`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                        data: {
                            deletion_reason: deletionReason
                        }
                    });

                    setDeal(deals.filter((contact) => contact.id !== id));
                    Swal.fire(
                        "Deleted!",
                        "The deal has been deleted.",
                        "success"
                    );
                } catch (error) {
                    console.error('Error deleting deal:', error);
                    Swal.fire(
                        "Error!",
                        "Failed to delete deal. Please try again.",
                        "error"
                    );
                }
            }
        });
    };

    const handleShowModal = (contactId = null) => {
        if (contactId) {
            const contactToEdit = deals.find((contact) => contact.id === contactId);
            if (contactToEdit) {
                setSelectedDealData(contactToEdit);
            }
        } else {
            setSelectedDealData(null);
        }
        setSelectedDealId(contactId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedDealId(null);
        setSelectedDealData(null);
        setErrors({});
    };

    const handlePageClick = (data) => {
        const selectedPage = data.selected + 1;
        fetchDeal(selectedPage);
    };


    const getContactNameById = (contactId) => {
        const contact = contacts.find(contact => contact.id == contactId);
        return contact ? contact.name : '';
    };
    const formatOrgType = (type) => {
        if (!type) return ''; // Return empty string if type is null or undefined
        return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase().replace(/_/g, ' ');
    };

    const [viewType, setViewType] = useState('list');

    const getStageBadgeColor = (stage) => {
        const stageColors = {
            "suspect": "bg-warning",
            "prospect": "bg-info",
            "approach": "bg-primary",
            "negotiation": "bg-secondary",
            "closed won": "bg-success",
            "closed lost": "bg-danger",
            "closed dead": "bg-dark",
            "order": "bg-success"
        };
        return stageColors[stage] || "bg-light";  // Default to light if no match
    };
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setDateRange((prev) => ({ ...prev, [name]: value }));
    };
    const applyDateFilter = () => {
        setDateFilterDropdown(false); // Close the dropdown after applying
        fetchDeal();
    };
    const clearDateFilter = () => {
        setDateRange({ from: "", to: "" }); // Reset date inputs
    };
    const handleFilterChange = (filterType, value) => {
        if (filterType === 'org') setorgFilter(value);
        if (filterType === 'type') setTypeFilter(value);
        if (filterType === 'stage') setStageFilter(value);

        setFilterDropdown(null); // Close dropdown after selection
    };


    const handleShowLeadDetails = (dealId) => {
        setSelectedDealId(dealId);
        setShowLeadOffcanvas(true);
    };

    const handleCloseLeadDetails = () => {
        setShowLeadOffcanvas(false);
        setSelectedDealId(null);
    };

    return (
        <>
            {viewType === 'list' ? (

                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <h4 className="mb-sm-0 font-size-18">
                                            Opportunities
                                        </h4>

                                        <div className="d-flex align-items-center gap-3">
                                            {/* Search Box */}
                                            <div className="search-box">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search by deal, organisation, or lead..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>

                                            {/* View Type Toggle */}
                                            <ul className="nav nav-pills">
                                                <li className="nav-item" data-bs-placement="top" title="List">
                                                    <a
                                                        className={`nav-link ${viewType === 'list' ? 'bg-primary bg-soft' : ''}`}
                                                        href="#"
                                                        onClick={() => setViewType('list')}
                                                    >
                                                        <i className="mdi mdi-format-list-bulleted" />
                                                    </a>
                                                </li>
                                                <li className="nav-item" data-bs-placement="top" title="Grid">
                                                    <a
                                                        className={`nav-link ${viewType === 'grid' ? 'bg-primary bg-soft' : ''}`}
                                                        href="#"
                                                        onClick={() => setViewType('grid')}
                                                    >
                                                        <i className="mdi mdi-view-grid-outline" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-end align-items-center mb-3">
                                                {/* Add Deal Button */}
                                                <WithCreatePermission>
                                                    <button
                                                        type="button"
                                                        className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                                                        onClick={() => handleShowModal()}
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        title="Add Deal"
                                                    >
                                                        <i className="mdi mdi-plus" style={{ fontSize: "16px" }}></i>
                                                    </button>
                                                </WithCreatePermission>
                                            </div>
                                            <table className="table align-middle table-nowrap table-check table-list">
                                                <thead className="table-sales-gradient">
                                                    <tr>
                                                        <th style={{ width: '20px' }} className="align-middle">
                                                            <div className="form-check font-size-16">
                                                                <input className="form-check-input" type="checkbox" id="checkAll" />
                                                                <label className="form-check-label" htmlFor="checkAll"></label>
                                                            </div>
                                                        </th>
                                                        <th className="align-middle">#</th>
                                                        <th className="align-middle"> Name</th>
                                                        <th className="align-middle">Organisation
                                                            <div className="dropdown d-inline-block">
                                                                <FaFilter
                                                                    className="ms-2 cursor-pointer filter-color"
                                                                    onClick={() => setFilterDropdown(filterDropdown === 'org' ? null : 'org')}
                                                                />
                                                                {filterDropdown === 'org' && (
                                                                    <ul className="dropdown-menu show">
                                                                        <li><button className="dropdown-item" onClick={() => handleFilterChange('org', '')}>All</button></li>
                                                                        {organisations.map((type) => (
                                                                            <li key={type.id}>
                                                                                <button className="dropdown-item" onClick={() => handleFilterChange('org', type.id)}>
                                                                                    {type.name}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                )}
                                                            </div>
                                                        </th>
                                                        <th className="align-middle">Stage
                                                            <div className="dropdown d-inline-block">
                                                                <FaFilter
                                                                    className="ms-2 cursor-pointer filter-color"
                                                                    onClick={() => setFilterDropdown(filterDropdown === 'stage' ? null : 'stage')}
                                                                />
                                                                {filterDropdown === 'stage' && (
                                                                    <ul className="dropdown-menu show">
                                                                        <li>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('stage', '')}>
                                                                                All
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('stage', 'suspect')}>
                                                                                Suspect
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('stage', 'prospect')}>
                                                                                Prospect
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('stage', 'approach')}>
                                                                                Approach
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('stage', 'negotiation')}>
                                                                                Negotiation
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('stage', 'closed won')}>
                                                                                Closed Won
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('stage', 'closed lost')}>
                                                                                Closed Lost
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('stage', 'closed dead')}>
                                                                                Closed Dead
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item" onClick={() => handleFilterChange('stage', 'order')}>
                                                                                Order
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                )}
                                                            </div>
                                                        </th>
                                                        <th className="align-middle">Value</th>

                                                        <th className="align-middle">Closed Date
                                                            <div className="dropdown d-inline-block">
                                                                <FaFilter
                                                                    className="ms-2 cursor-pointer filter-color"
                                                                    onClick={() => setDateFilterDropdown(!dateFilterDropdown)}
                                                                />
                                                                {dateFilterDropdown && (
                                                                    <div className="dropdown-menu show p-3" style={{ minWidth: '250px' }}>
                                                                        <label className="form-label">From</label>
                                                                        <input type="date" className="form-control mb-2" name="from" value={dateRange.from} onChange={handleDateChange} />

                                                                        <label className="form-label">To</label>
                                                                        <input type="date" className="form-control mb-2" name="to" value={dateRange.to} onChange={handleDateChange} />

                                                                        <div className="text-end mt-3">
                                                                            <button className="btn btn-primary btn-sm d-inline-block w-auto me-2" onClick={applyDateFilter}>
                                                                                Apply
                                                                            </button>
                                                                            <button className="btn btn-secondary btn-sm d-inline-block w-auto" onClick={clearDateFilter}>
                                                                                Clear
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div></th>

                                                        <th className="align-middle">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {deals.length > 0 ? (
                                                        deals.map((deal, index) => (
                                                            <tr key={deal.id}>
                                                                <td>
                                                                    <div className="form-check font-size-16">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id={`dealCheck${index}`}
                                                                        />
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor={`dealCheck${index}`}
                                                                        ></label>
                                                                    </div>
                                                                </td>
                                                                <td>{index + 1}</td>

                                                                <td>
                                                                    <button
                                                                        onClick={() => handleShowLeadDetails(deal.id)} // Pass lead ID
                                                                        className="dropdown-item"
                                                                    >
                                                                        {deal.name}
                                                                    </button>
                                                                </td>

                                                                <td> {deal.organisation ? deal.organisation.name : " "}</td>
                                                                <td>{deal.stage}</td>
                                                                <td>
                                                                    {formatCurrency(deal.value, deal)}
                                                                </td>

                                                                <td>{deal.closed_date}</td>

                                                                <td>
                                                                    <div className="dropdown">
                                                                        <i
                                                                            className="mdi mdi-dots-horizontal font-size-18"
                                                                            data-bs-toggle="dropdown"
                                                                            aria-expanded="false"
                                                                            style={{ cursor: 'pointer' }}
                                                                        ></i>
                                                                        <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                            <li>
                                                                                <button
                                                                                    onClick={() => handleShowLeadDetails(deal.id)} // Pass lead ID
                                                                                    className="dropdown-item"
                                                                                >
                                                                                    View Details
                                                                                </button>

                                                                            </li>
                                                                            <li><WithEditPermission>
                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => handleShowModal(deal.id)}
                                                                                >
                                                                                    Edit
                                                                                </button></WithEditPermission>
                                                                            </li>
                                                                            <li><WithDeletePermission>
                                                                                <button
                                                                                    className="dropdown-item"
                                                                                    onClick={() => deleteDeal(deal.id)}
                                                                                >
                                                                                    Delete
                                                                                </button></WithDeletePermission>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center">No deals found.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            <div className="d-flex justify-content-end pagination-sm">
                                                <ReactPaginate
                                                    previousLabel={'<'}
                                                    nextLabel={'>'}
                                                    breakLabel={'...'}
                                                    pageCount={pageCount}
                                                    marginPagesDisplayed={2}
                                                    pageRangeDisplayed={3}
                                                    onPageChange={handlePageClick}
                                                    containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                                                    pageClassName={'page-item'}
                                                    pageLinkClassName={'page-link'}
                                                    previousClassName={'page-item previous'}
                                                    previousLinkClassName={'page-link'}
                                                    nextClassName={'page-item next'}
                                                    nextLinkClassName={'page-link'}
                                                    breakClassName={'page-item'}
                                                    breakLinkClassName={'page-link'}
                                                    activeClassName={'active'}
                                                />
                                            </div>
                                        </div>
                                    </div>




                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            ) : (

                <DealsbyStage />

            )}


            <DealModal
                showModal={showModal}
                handleClose={handleCloseModal}
                dealId={selectedDealId}
                dealData={selectedDealData}
                addDeal={addDeal}
                editDeal={editDeal}
                deals={deals}
                fetchOrganisation={fetchOrganisation}
                errors={errors}
                setErrors={setErrors}
                organisations={organisations}
                setOrganisation={setOrganisation}

            />
            <DealDetails
                show={showLeadOffcanvas}
                onHide={handleCloseLeadDetails}
                dealId={selectedDealId}
            // onOrganisationUpdate={fetchOrganisation} // Pass refresh function if needed
            />
        </>
    );
};
export default DealList;




